
export default class Environment {
    static isLocal = window.location.hostname === 'localhost';
    static isTest = window.location.hostname.includes('test-');
    static isDev = window.location.hostname.includes('dev-klayoapp');
    static isProduction = !Environment.isLocal && !Environment.isTest && !Environment.isDev;

    static get() {
        if(Environment.isProduction) return 'Production';
        if(Environment.isLocal) return 'Local';
        if(Environment.isTest) return 'Test';
        if(Environment.isDev) return 'Dev';
    }
}
